import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { useServerSession } from '../hooks/useServerSession'

/**
 *  A wrapper for <Route> that redirects to the login
 *  screen if you're not yet authenticated.
 * @param children
 * @param rest
 * @constructor
 */
export function PrivateRoute({
  children,
  ...rest
}: React.PropsWithChildren<any>) {
  const { sessionInfo, isSessionLoading } = useServerSession()
  return (
    <Route
      {...rest}
      render={({ location }) =>
        sessionInfo ? (
          children
        ) : isSessionLoading ? (
          <div>Loading...</div>
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  )
}
